import { Component, OnInit, Input } from '@angular/core';
import { get } from 'lodash';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent implements OnInit {

  @Input() controls: Array<any> = [];
  @Input() config: {
    padding: {
      top: number,
      bottom: number,
      right: number,
      left: number
    },
    margin: {
      top: number,
      bottom: number,
      right: number,
      left: number
    },
    backgroundColor: string,
    border: string,
    borderRadius: {
      topLeft: number,
      topRight: number,
      bottomLeft: number,
      bottomRight: number
    },
    float?: string
  };
  style: object = {};
  constructor() { }

  ngOnInit() {
    this.style = this.getStyle();
  }

  /**
   * set style to div tag
   * @author Lalitkumar Saindane
   * @return [style object]
   * @task QLIKTAG-3245
   */
  getStyle() {
    return {
      'padding-top': this.getPxValue(this.config, 'padding.top'),
      'padding-bottom':  this.getPxValue(this.config, 'padding.bottom'),
      'padding-right':  this.getPxValue(this.config, 'padding.right'),
      'padding-left':  this.getPxValue(this.config, 'padding.left'),
      'margin-top':  this.getPxValue(this.config, 'margin.top'),
      'margin-bottom':  this.getPxValue(this.config, 'margin.bottom'),
      'margin-right':   this.getPxValue(this.config, 'margin.right'),
      'margin-left':   this.getPxValue(this.config, 'margin.left'),
      'background-color': get(this.config, 'backgroundColor', 'transparent'),
      'border': get(this.config, 'border', 'none'),
      'border-top-left-radius': this.getPxValue(this.config, 'borderRadius.topLeft'),
      'border-top-right-radius': this.getPxValue(this.config, 'borderRadius.topRight'),
      'border-bottom-right-radius': this.getPxValue(this.config, 'borderRadius.bottomRight'),
      'border-bottom-left-radius': this.getPxValue(this.config, 'borderRadius.bottomLeft'),
      'float': this.getAlignment(this.config),
    };
  }

  /**
   * add px to value
   * @author Lalitkumar Saindane
   * @param  obj  [input Object]
   * @param  path [path]
   * @param defaultValue [defaultValue]
   * @return [value]
   * @task QLIKTAG-3245
   */
  getPxValue(obj, path, defaultValue= 0) {
    let result = get(obj, path);
    let output;
    if (result && result !== '') {
      output = `${result}px`;
    } else {
      output = `${defaultValue}px`;
    }
    return output;
  }

  /**
   * Float Property value 
   * @author Neil C
   * @param  config  [Section control config object]
   * @return [string: Left | Right]
   * @task QLIKTAG-3245
   */
  getAlignment(config):string {
    let value = 'none';

    if(config && config.hasOwnProperty('float')){
      return config.float;
    }

    return value;
  }
}
